import { FC, useState } from 'react';
import { Outlet } from 'react-router-dom';
import AppLayoutToolbar from '@amzn/awsui-components-core/app-layout-toolbar';
import Header, { STICKY_HEADER_STYLE, HEADER_WRAPPER_ID } from 'src/components/organisms/Header';
import Nav from 'src/components/organisms/Nav';
import { usePageViewMetric } from 'src/hooks/usePageViewMetric';

import '@amzn/awsui-global-styles/polaris.css';

/** Check if viewport is narrow (mobile/tablet) */
const isNarrowViewport = () => window.innerWidth < 768;

const AppLayoutWithNav: FC = () => {
  const [navigationOpen, setNavigationOpen] = useState(!isNarrowViewport());

  usePageViewMetric();

  return (
    <>
      <div id={HEADER_WRAPPER_ID} style={STICKY_HEADER_STYLE}>
        <Header />
      </div>
      <AppLayoutToolbar
        headerSelector={`#${HEADER_WRAPPER_ID}`}
        navigation={<Nav />}
        navigationOpen={navigationOpen}
        onNavigationChange={({ detail }) => setNavigationOpen(detail.open)}
        content={<Outlet />}
      />
    </>
  );
};

export default AppLayoutWithNav;
